<template>
  <div class="main-wrapper-login-page">
    <nb-welcome-page
      v-if="loaded"
      class="welcome-page"
      domain="airport"
      :img="avionLigneImage"
    >
      <div class="welcome-page__login-container">
        <div class="welcome-page__login-container__title row">
          <h4
            class="welcome-page__reset-password-container__title"
            v-if="
              currentForm === 'ResetPassword' || currentForm === 'ResetConfirm'
            "
          >
            {{ $t(`welcomePage.forgotPasswordTitle`) }}
          </h4>
          <nb-icon
            name="analytics-optimize"
            size="big"
            v-if="currentForm === 'Login'"
          />
          <div class="m-l-n column" v-if="currentForm === 'Login'">
            <div class="welcome-page__login-container__title-entity"></div>
            <div class="welcome-page__login-container__title-app-name">
              <p>NAVBLUE Delivery Portal</p>
            </div>
          </div>
        </div>

        <nb-separator light class="separator"></nb-separator>

        <nb-form
          ref="form"
          :model="form"
          :rules="formRules"
          class="welcome-page__login-container__form"
          label-position="top"
          label-width="120px"
          size="small"
          label-color="white"
        >
          <div
            class="welcome-page__login-container-form-input__confirm"
            v-if="currentForm === 'ResetConfirm'"
          >
            <!-- ========================================== CONFIRM MESSAGE SECTION =================================================== -->
            <div style="display: inline-flex">
              <nb-icon name="mail-sent" size="big" />
              <h5 class="welcome-page__reset-password-container-form-text">
                {{ $t(`welcomePage.confirmMessage`) }}
              </h5>
            </div>
            <!-- ========================================== END CONFIRM MESSAGE SECTION =================================================== -->
          </div>
          <!-- ========================================== RESET MESSAGE SECTION =================================================== -->
          <div
            class="welcome-page__login-container-form-input__reset"
            v-if="currentForm === 'ResetPassword'"
          >
            <div class="welcome-page__reset-password-container-form-text">
              {{
                $t(
                  `Enter your email address and we will send you an email with a new generated password`
                )
              }}
            </div>
            <!-- ========================================== END RESET MESSAGE SECTION =================================================== -->
            <!-- ========================================== RESET EMAIL SECTION =================================================== -->
            <nb-form-item :label="$t(`welcomePage.email`)">
              <nb-input
                v-model="form.emailReset"
                placeholder="Email address"
                size="large"
              />
            </nb-form-item>
            <!-- ========================================== END RESET EMAIL SECTION =================================================== -->
            <!-- ========================================== LOGIN FORM SECTION =================================================== -->
          </div>
          <div
            class="welcome-page__login-container-form-input"
            v-if="currentForm === 'Login'"
          >
            <!-- ========================================== LOGIN SECTION =================================================== -->
            <nb-form-item
              prop="login"
              :label="$t(`welcomePage.login`)"
              :rules="[
                {
                  type: 'email',
                  message: 'Please input correct email address',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <nb-input
                v-model="form.login"
                size="large"
                status="success"
                placeholder="email@address.com"
                show-succes-icon
              />
            </nb-form-item>
            <!-- ========================================== END LOGIN SECTION =================================================== -->
            <!-- ========================================== PASSWORD SECTION =================================================== -->
            <nb-form-item
              class="welcome-page__login-container-form-input-password"
              prop="password"
              :label="$t(`welcomePage.password`)"
              size="medium"
            >
              <nb-input
                v-model="form.password"
                class="password-input"
                :type="show ? 'text' : 'password'"
                icon="view"
                @icon-click="toggleShowPassword"
                size="large"
                placeholder="Password"
              />
            </nb-form-item>
            <!-- ========================================== END PASSWORD SECTION =================================================== -->
          </div>
          <!-- ========================================== END LOGIN FORM SECTION =================================================== -->
          <!-- ========================================== FORGOT PASSWORD SECTION =================================================== -->
          <div
            class="welcome-page__login-container-forgot-password"
            v-if="currentForm === 'Login'"
          >
            <nb-button
              class="forgot-password-button"
              color="rgb(255, 255, 255)"
              simple
              @click="currentForm = 'ResetPassword'"
            >
              {{ $t(`welcomePage.forgotPassword`) }}
            </nb-button>
            <!--
            <nb-checkbox v-model="checked"
              >{{ $t(`welcomePage.rememberMe`) }}
            </nb-checkbox> -->
          </div>
          <!-- ========================================== END FORGOT PASSWORD SECTION =================================================== -->
          <nb-separator light class="separator"></nb-separator>
          <!-- ========================================== ACTIONS SECTION =================================================== -->
          <nb-form-item class="welcome-page__login-container-form-button">
            <!-- ========================================== RESET PASSWORD SECTION =================================================== -->
            <nb-button
              v-if="currentForm === 'ResetPassword'"
              class="reset-button"
              color="rgb(255, 255, 255)"
              type="primary"
              size="normal"
              simple
              @click="currentForm = 'Login'"
              >{{ $t(`welcomePage.cancelPasswordButton`) }}</nb-button
            >
            <nb-button
              v-if="currentForm === 'ResetPassword'"
              class="reset-button"
              color="rgb(254, 48, 84)"
              type="primary"
              size="normal"
              @click="resetPasswordFunction"
              :disabled="loadingStatus"
              >{{ $t(`welcomePage.resetPasswordButton`) }}</nb-button
            >
            <!-- ========================================== END RESET PASSWORD SECTION =================================================== -->
            <!-- ========================================== RESET CONFIRM SECTION =================================================== -->
            <nb-button
              v-if="currentForm === 'ResetConfirm'"
              class="reset-button"
              color="rgb(254, 48, 84)"
              type="primary"
              size="normal"
              @click="currentForm = 'Login'"
              >{{ $t(`welcomePage.confirmButton`) }}</nb-button
            >
            <!-- ========================================== END RESET CONFIRM SECTION =================================================== -->
            <nb-button
              v-if="currentForm === 'Login'"
              class="login-button"
              color="rgb(254, 48, 84)"
              type="primary"
              size="large"
              :disabled="disabledLoginBtn"
              @click="submitForm"
              >{{ $t(`welcomePage.login`) }}</nb-button
            >
          </nb-form-item>
          <!-- ========================================== END ACTIONS SECTION =================================================== -->
        </nb-form>
      </div>
    </nb-welcome-page>
  </div>
</template>

<script>
import Vue from "vue";
import Component from "vue-class-component";
import router from "@/router/router";
import store from "@/store/store";
import {
  fetchList,
  authentContact,
  resetPassword,
} from "../API/APIFunctions.js";
import { mapActions, mapGetters } from "vuex";
import {
  Icon,
  Form,
  FormItem,
  Button,
  Input,
  Separator,
  WelcomePage,
} from "@navblue/navblue-ui";

@Component({
  components: {
    NbIcon: Icon,
    NbForm: Form,
    NbFormItem: FormItem,
    NbButton: Button,
    NbInput: Input,
    NbSeparator: Separator,
    NbWelcomePage: WelcomePage,
  },
  computed: {
    avionLigneImage: function () {
      return this.publicPath + "avion-ligne.png";
    },
    ...mapGetters(["getCurrentUser"]),
  },
  methods: {
    ...mapActions({
      fetchUserAndCustomer: "fetchUserAndCustomer",
      getContactAndCustomerData: "getContactAndCustomerData",
    }),
  },
})
export default class Login extends Vue {
  data() {
    return {
      publicPath: process.env.BASE_URL,
      userSelected: null,
      userList: null,
      currentForm: "Login", // Login | ResetPassword | ResetConfirm
      form: {
        login: "",
        password: "",
      },
      formRules: {
        login: [
          { validator: this.validateLogin, required: true, trigger: "change" },
        ],
        password: [
          {
            validator: this.validatePassword,
            required: true,
            trigger: "change",
          },
        ],
      },
      checked: false,
      show: false,
      disabledLoginBtn: true,
      loaded: false,
      loadingStatus: false,
    };
  }

  mounted() {
    if (this.form.login !== "" && this.form.password !== "") {
      this.disabledLoginBtn = false;
    }
    this.loaded = true;

    if (!!this.$route.query.id && !!this.$route.query.bulletinType) {
      this.$store.commit("setBulletinId", this.$route.query.id);
      this.$store.commit("setBulletinType", this.$route.query.bulletinType);
    }
  }

  resetPasswordFunction() {
    var localThis = this;
    this.callResetPasswordApi().then((resetResult) => {
      localThis.loadingStatus = false;
      if (resetResult) {
        localThis.currentForm = "ResetConfirm";
      } else {
        // If email do not exist or if error has occur during call
        localThis.$Notify({
          title:
            "A new password can not be generated for this email address. Please contact the support : navdatasupport@navblue.aero",
          duration: 3000,
          type: "error",
          topOffset: 50,
        });
      }
    });
  }

  async submitForm() {
    var localThis = this;
    this.authenticate().then((authentResult) => {
      if (authentResult) {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.disabledLoginBtn = false;
            this.getContactAndCustomerData(this.form.login).then(function () {
              if (localThis.getCurrentUser.isFirstConnexion) {
                router.push("admin");
              } else {
                router.push("main");
              }
            });
          } else {
            return false;
          }
        });
      } else {
        this.$Notify.error({
          title: "Error while trying to login",
          message: "Incorrect password or login",
          duration: 3000,
        });
      }
    });
  }

  validateLogin(rule, value, callback) {
    if (value === "") {
      callback(new Error("Please type your login"));
    } else {
      callback();
    }
    this.checkIfFieldIsNotEmpty();
  }

  validatePassword(rule, value, callback) {
    if (value === "") {
      callback(new Error("Please type your password"));
    } else {
      callback();
    }
    this.checkIfFieldIsNotEmpty();
  }

  checkIfFieldIsNotEmpty() {
    if (this.form.login !== "" && this.form.password !== "") {
      this.disabledLoginBtn = false;
    } else {
      this.disabledLoginBtn = true;
    }
  }

  toggleShowPassword() {
    this.show = !this.show;
  }

  async authenticate() {
    if (this.form.login === null || this.form.password === null) return false;
    else {
      return authentContact(this.form.login, this.form.password);
    }
  }

  async callResetPasswordApi() {
    var localThis = this;
    try {
      if (this.form.emailReset == "") return false;
      else {
        localThis.loadingStatus = true;
        return resetPassword(this.form.emailReset);
      }
    } catch (err) {
      throw err;
    }
  }
}
</script>

<style lang="scss">
.main-wrapper-login-page {
  position: relative;
  height: 100%;

  .modal_content {
    text-align: center;
  }

  .welcome-page {
    .nb-welcome-page__corner-icon {
      width: calc(8 * var(--unit));
      height: calc(8 * var(--unit));
    }
    /deep/.nb-welcome-page__form {
      display: flex;
      align-items: center;
      background-color: var(--color-grey-1);
      width: calc(28 * var(--unit)); //448px
      padding: 0px;
      .nb-welcome-page__formcontent {
        width: 100%;
        padding: calc(3 * var(--spacer-default)); //48px
      }
    }
    .welcome-page__login-container {
      .welcome-page__login-container__title {
        margin-bottom: var(--spacer-default);
        .welcome-page__login-container__title-app-name {
          font-size: var(--font-size-h-2);
          font-weight: bold;
        }
      }
      .welcome-page__reset-password-container__title {
        color: var(--color-white);
      }
      .welcome-page__login-container-form-input__confirm {
        margin: var(--spacer-l) 0px;
        .nb-icon {
          margin: calc(1.5 * var(--spacer-default)) 0px;
        }
        .welcome-page__reset-password-container-form-text {
          color: var(--color-white);
          font-size: var(--font-size-text);
          padding-left: calc(2 * var(--spacer-default)); //32px
        }
      }
      .welcome-page__login-container-form-input__reset {
        margin: var(--spacer-xl) 0px var(--spacer-xl) 0px;
        .welcome-page__reset-password-container-form-text {
          color: var(--color-white);
          font-size: var(--font-size-text);
          margin: 0px 0px calc(2 * var(--spacer-default));
        }
      }
      .welcome-page__login-container-form-input {
        margin: var(--spacer-xl) 0px var(--spacer-l) 0px;
        .welcome-page__reset-password-container-form-text {
          color: var(--color-white);
          font-size: var(--font-size-text);
          margin: 0px 0px calc(2 * var(--spacer-default));
        }
        .bottom-section {
          text-align: right;
        }
      }
      .welcome-page__login-container-forgot-password {
        margin-bottom: var(--spacer-l);
        .nb-checkbox {
          float: right;
          margin-top: calc(0.25 * var(--spacer-default)); //4px
        }
      }
      .welcome-page__login-container-form-button {
        display: flex;
        justify-content: flex-end;
        .login-button {
          margin-top: calc(2 * var(--spacer-default));
          padding: 0px var(--spacer-xl);
        }
        .reset-button {
          margin-top: calc(1.5 * var(--spacer-default));
          padding: 0px var(--spacer-l);
        }
      }
    }
  }
}
</style>
